import { useState, useEffect } from "react";
import { Button, Modal, Form, Table } from "react-bootstrap";
import { PencilSquare } from "react-bootstrap-icons";
import API from "../api";

const opciones = [
  { nombre: "Áreas", endpoint: "/areas" },
  { nombre: "Cargos", endpoint: "/cargos" },
  { nombre: "Roles", endpoint: "/roles" },
  { nombre: "Jornadas", endpoint: "/jornadas" },
  { nombre: "Tipos de Contrato", endpoint: "/tiposcontrato" },
];

const ParametrosSistema = () => {
  const [opcionActiva, setOpcionActiva] = useState(opciones[0]);
  const [datos, setDatos] = useState([]);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [nuevoCampo, setNuevoCampo] = useState("");
  const [areaSeleccionada, setAreaSeleccionada] = useState(null);
  const [areasParaCargos, setAreasParaCargos] = useState([]);

  useEffect(() => {
    if (!opcionActiva) return;

    if (opcionActiva.nombre === "Cargos") {
      fetch(`${API}/areas`)
        .then((res) => res.json())
        .then((data) => {
          setAreasParaCargos(data);
          setDatos([]); // Limpiamos datos al cambiar opción
        })
        .catch((err) => console.error("Error al cargar áreas:", err));
    } else {
      fetch(`${API}${opcionActiva.endpoint}`)
        .then((res) => res.json())
        .then((data) => setDatos(data))
        .catch((err) => console.error("Error al cargar datos:", err));
    }
  }, [opcionActiva]);

  useEffect(() => {
    if (opcionActiva.nombre === "Cargos" && areaSeleccionada) {
      fetch(`${API}/cargos`)
        .then((res) => res.json())
        .then((data) => {
          const filtrados = data.filter((c) => c.area_id === areaSeleccionada);
          setDatos(filtrados);
        })
        .catch((err) => console.error("Error al filtrar cargos por área:", err));
    }
  }, [areaSeleccionada]);

  const abrirModal = () => setMostrarModal(true);
  const cerrarModal = () => {
    setMostrarModal(false);
    setNuevoCampo("");
  };

  return (
    <div className="container py-4">
      <div className="d-flex align-items-start">
        {/* Menú vertical */}
        <div className="nav flex-column nav-pills me-3" style={{ minWidth: "200px" }} role="tablist">
          {opciones.map((op) => (
            <button
              key={op.nombre}
              className={`nav-link ${opcionActiva.nombre === op.nombre ? "active" : ""}`}
              onClick={() => {
                setOpcionActiva(op);
                setAreaSeleccionada(null);
              }}
              type="button"
            >
              {op.nombre}
            </button>
          ))}
        </div>

        {/* Panel derecho */}
        <div className="tab-content flex-grow-1 border rounded p-4 bg-white shadow-sm" style={{ maxWidth: "720px" }}>
          {!(opcionActiva.nombre === "Cargos" && !areaSeleccionada) && (
            <div className="d-flex justify-content-end mb-2">
              <Button variant="primary" size="sm" onClick={abrirModal}>
                + Agregar campo
              </Button>
            </div>
          )}

          {/* Cargos: mostrar selector de área primero */}
          {opcionActiva.nombre === "Cargos" && !areaSeleccionada ? (
            <>
              <p className="text-muted">Seleccione un área para ver los cargos asociados:</p>
              <ul className="list-group">
                {areasParaCargos.map((area) => (
                  <li
                    key={area._id}
                    className="list-group-item list-group-item-action"
                    style={{ cursor: "pointer" }}
                    onClick={() => setAreaSeleccionada(area._id)}
                  >
                    {area.nombre}
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <div className="table-responsive">
              <Table
                striped
                bordered
                hover
                size="sm"
                className="align-middle text-center table-sm"
                style={{ width: "100%", minWidth: "400px" }}
              >
                <thead className="table-dark">
                  <tr>
                    <th style={{ width: "70%" }}>Nombre</th>
                    <th style={{ width: "30%" }}>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {datos.map((item) => (
                    <tr key={item._id}>
                      <td>{item.nombre}</td>
                      <td className="d-flex justify-content-center align-items-center">
                        <PencilSquare style={{ cursor: "pointer" }} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </div>

      {/* MODAL */}
      <Modal show={mostrarModal} onHide={cerrarModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Agregar nuevo campo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="nuevoCampo">
            <Form.Label>Nombre del campo</Form.Label>
            <Form.Control
              type="text"
              value={nuevoCampo}
              onChange={(e) => setNuevoCampo(e.target.value)}
              placeholder="Ejemplo: Supervisor"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cerrarModal}>
            Cancelar
          </Button>
          <Button variant="primary">Guardar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ParametrosSistema;
